'use es6';

import { makeAsyncComponentWithOverlay } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import makeAsyncEmojiPickerContent from 'ui-addon-emoji-picker/picker/makeAsyncEmojiPickerContent';
export const AsyncEmojiPicker = makeAsyncEmojiPickerContent(() => import( /* webpackChunkName: "emoji-picker" */'ui-addon-emoji-picker/picker/EmojiPickerContent'));
const AsyncCtaPicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: 'cta-picker' */'EmailEditorUI/containers/EmailCTAPickerContainer'));
const AsyncFilePicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "file-picker" */'ContentEditorUI/components/shared/FilePicker'));
const AsyncMediaBridgePicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "media-bridge-picker" */'media-bridge-lib/components/media-picker/MediaPicker'));
const AsyncHubSpotVideoPicker = makeAsyncComponentWithOverlay(() => import( /* webpackChunkName: "legacy-video-picker-facade" */'video-components-external/components/LegacyVideoPickerFacade').then(module => module.LegacyVideoPickerFacade));
export const pickerComponents = {
  CtaPicker: AsyncCtaPicker,
  FilePicker: AsyncFilePicker,
  EmojiPicker: AsyncEmojiPicker,
  MediaBridgePicker: AsyncMediaBridgePicker,
  HubSpotVideoPicker: AsyncHubSpotVideoPicker
};